var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfectiousSubstancesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52610",
    "data-name": "Group 52610",
    transform: "translate(-443 -3336.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18512",
    "data-name": "Rectangle 18512",
    transform: "translate(443 3336.927)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_23_",
    "data-name": "svgexport-7 (23)",
    transform: "translate(437.497 3351.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91055",
    "data-name": "Path 91055",
    d: "M138.579,7.5h0A14.262,14.262,0,0,1,152.84,21.762V53.777H124.317V21.762A14.262,14.262,0,0,1,138.579,7.5Z",
    transform: "translate(-91.076 -6.688)",
    fill: "#a2b953"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91056",
    "data-name": "Path 91056",
    d: "M60.514,297.717v-4.423H47.868v4.423A4.3,4.3,0,0,1,45,301.773l-9.585,3.4a8.61,8.61,0,0,0-5.736,8.111v1.154a1.731,1.731,0,0,0,1.733,1.729H76.969a1.731,1.731,0,0,0,1.733-1.729v-1.154a8.61,8.61,0,0,0-5.736-8.111l-9.585-3.4a4.3,4.3,0,0,1-2.868-4.055Z",
    transform: "translate(-6.688 -261.529)",
    fill: "#a2b953"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91057",
    "data-name": "Path 91057",
    d: "M248.4,391.028l.011-12.97a.812.812,0,0,1,.812-.811h0a.812.812,0,0,1,.811.813l-.011,12.97Z",
    transform: "translate(-201.716 -336.39)",
    fill: "#dddbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91058",
    "data-name": "Path 91058",
    d: "M199.354,302.327c.41.405.869.826,1.378,1.252.431.36.853.685,1.259.978a.647.647,0,0,0,.757,0c.407-.293.83-.618,1.261-.979.509-.425.967-.847,1.375-1.252l4.082-2.15a4.292,4.292,0,0,1-.774-2.46v-4.423H196.047v4.423a4.288,4.288,0,0,1-.191,1.265Z",
    transform: "translate(-154.866 -261.529)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91059",
    "data-name": "Path 91059",
    d: "M287.755,342.166l1.193-5.19a.217.217,0,0,0-.017-.145l-1.475-2.953a.216.216,0,0,0-.39.006,14.659,14.659,0,0,1-1.28,2.252,22.944,22.944,0,0,1-1.945,2.273l2.746,3.982a.65.65,0,0,0,1.168-.223Z",
    transform: "translate(-233.322 -297.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91060",
    "data-name": "Path 91060",
    d: "M182.149,342.166l-1.193-5.19a.217.217,0,0,1,.017-.145l1.475-2.953a.216.216,0,0,1,.39.006,14.661,14.661,0,0,0,1.28,2.252,22.946,22.946,0,0,0,1.945,2.273l-2.746,3.982a.65.65,0,0,1-1.168-.223Z",
    transform: "translate(-141.576 -297.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91061",
    "data-name": "Path 91061",
    d: "M197.62,297.589c.095.06.191.119.288.175l4.352,2.517a3.34,3.34,0,0,0,3.344,0l4.352-2.517c.105-.061.208-.125.311-.19v-4.281H197.62Z",
    transform: "translate(-156.44 -261.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91062",
    "data-name": "Path 91062",
    d: "M118.262,384.248l.051,0a.812.812,0,0,0,.81-.762,7.875,7.875,0,0,1,.37-1.95,8.046,8.046,0,0,1,1.647-2.845l-2.594.921a9.356,9.356,0,0,0-.6,1.422,9.5,9.5,0,0,0-.446,2.352A.812.812,0,0,0,118.262,384.248Z",
    transform: "translate(-84.996 -337.679)",
    fill: "#a4aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91063",
    "data-name": "Path 91063",
    d: "M87.61,422.256h-2a.812.812,0,1,1,0-1.625h1.733v-.65a3.357,3.357,0,1,0-6.715,0v.65h1.733a.812.812,0,1,1,0,1.625h-2A1.355,1.355,0,0,1,79,420.9v-.921a4.982,4.982,0,0,1,9.964,0v.921A1.355,1.355,0,0,1,87.61,422.256Z",
    transform: "translate(-50.667 -370.054)",
    fill: "#596381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91064",
    "data-name": "Path 91064",
    d: "M375.316,386.365a10.879,10.879,0,0,1,.44,1.988.813.813,0,0,0,.8.712.847.847,0,0,0,.1-.006.812.812,0,0,0,.705-.907,12.433,12.433,0,0,0-1.229-4.048l-2.424-.861A10.966,10.966,0,0,1,375.316,386.365Z",
    transform: "translate(-313.463 -341.737)",
    fill: "#a4aed3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498",
    cx: 2.437,
    cy: 2.437,
    r: 2.437,
    transform: "translate(60.662 46.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91065",
    "data-name": "Path 91065",
    d: "M176.99,112.182a4.6,4.6,0,0,1,4.6,4.6v7.136a10.287,10.287,0,1,1-20.573-.129v-7.007a4.6,4.6,0,0,1,4.6-4.6Z",
    transform: "translate(-123.804 -100.032)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91066",
    "data-name": "Path 91066",
    d: "M350.979,157.182h2.087a1.889,1.889,0,0,1,1.889,1.889v.007a3.971,3.971,0,0,1-3.971,3.971h0Z",
    transform: "translate(-293.189 -140.159)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91067",
    "data-name": "Path 91067",
    d: "M0,0H0A3.971,3.971,0,0,1,3.975,3.971v.007A1.889,1.889,0,0,1,2.087,5.866H0Z",
    transform: "translate(37.217 22.89) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91068",
    "data-name": "Path 91068",
    d: "M177.331,188.993l-4.352,2.517a3.34,3.34,0,0,1-3.344,0l-4.352-2.517a8.53,8.53,0,0,1-4.263-7.383v-2.688a19.989,19.989,0,0,1,10.374-3.967,19.4,19.4,0,0,1,10.2,3.967v2.688A8.53,8.53,0,0,1,177.331,188.993Z",
    transform: "translate(-123.805 -156.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91069",
    "data-name": "Path 91069",
    d: "M66.55,42.881l-3.984-1.415V15.074a15.074,15.074,0,0,0-30.148,0v26.4L28.456,42.88a9.44,9.44,0,0,0-6.276,8.876V52.91a2.546,2.546,0,0,0,2.545,2.541H70.281a2.546,2.546,0,0,0,2.545-2.541V51.757a9.44,9.44,0,0,0-6.276-8.876ZM34.042,15.074a13.45,13.45,0,0,1,26.9,0v1.362a2.685,2.685,0,0,0-1.076-.224h-1.3a5.424,5.424,0,0,0-5.389-4.874H41.81a5.424,5.424,0,0,0-5.389,4.874h-1.3a2.683,2.683,0,0,0-1.077.225Zm7.594,17.064-.005,0A7.742,7.742,0,0,1,38.018,25.6V23.325a19.175,19.175,0,0,1,9.561-3.561,18.583,18.583,0,0,1,9.387,3.556V25.6a7.742,7.742,0,0,1-3.858,6.68h0L48.757,34.8a2.533,2.533,0,0,1-2.53,0c-.289-.167-4.346-2.5-4.591-2.662Zm.239,6.849a19.581,19.581,0,0,0,1.57,1.89l-2.164,3.137L40.22,39.392l.85-1.7c.247.445.517.879.806,1.3ZM38.018,21.36V16.754a3.8,3.8,0,0,1,3.792-3.792H53.174a3.8,3.8,0,0,1,3.792,3.792v4.592a20.2,20.2,0,0,0-3.54-1.84c-1.678-.67-4.078-1.522-5.915-1.367a20.8,20.8,0,0,0-9.493,3.221ZM53.131,38.987c.289-.418.558-.851.806-1.3l.85,1.7-1.062,4.622L51.56,40.877A19.585,19.585,0,0,0,53.131,38.987Zm1.507-3.378V33.228A9.372,9.372,0,0,0,58.591,25.6V23.632a4.764,4.764,0,0,0,2.351-1.127V40.889c-.731-.29-3.932-1.334-4.5-1.65a1.03,1.03,0,0,0-.1-.381L54.86,35.9a1.04,1.04,0,0,0-.222-.295Zm3.953-13.638V17.836h1.274a1.079,1.079,0,0,1,1.076,1.083A3.163,3.163,0,0,1,58.591,21.971Zm-22.2-4.136v4.137a3.167,3.167,0,0,1-2.351-3.06,1.077,1.077,0,0,1,1.076-1.076Zm-2.351,4.67a4.773,4.773,0,0,0,2.351,1.126V25.6a9.372,9.372,0,0,0,3.975,7.641v2.367a1.028,1.028,0,0,0-.222.293l-1.475,2.954a1.028,1.028,0,0,0-.1.381,3.493,3.493,0,0,1-.526.239l-4,1.42ZM46.68,53.826H24.725a.919.919,0,0,1-.921-.916V51.757A7.813,7.813,0,0,1,29,44.411L33.1,42.954c-.052.126-.1.254-.147.383A8.039,8.039,0,0,0,32.564,45a4.99,4.99,0,0,0-4.231,4.925v.921A1.355,1.355,0,0,0,29.687,52.2h2a.812.812,0,1,0,0-1.625H29.958v-.65a3.357,3.357,0,1,1,6.715,0v.65H34.94a.812.812,0,0,0,0,1.625h2A1.355,1.355,0,0,0,38.3,50.848v-.921a4.989,4.989,0,0,0-4.1-4.9,6.4,6.4,0,0,1,1.234-2.9l3.149-1.118c.106-.037.21-.079.313-.123l.885,3.852a1.462,1.462,0,0,0,2.628.5l2.208-3.2q.357.325.727.633c.433.362.884.71,1.345,1.041Zm-.294-12.4a14.269,14.269,0,0,1-3.175-3.363A13.886,13.886,0,0,1,42,35.935l-.009-.017V34.227l3.421,1.979a4.162,4.162,0,0,0,4.157,0l3.443-1.992v1.7L53,35.936a14.825,14.825,0,0,1-4.382,5.49c-.361.3-.736.593-1.118.872-.382-.279-.756-.57-1.117-.872ZM71.2,52.91a.919.919,0,0,1-.921.916H48.3l.01-10.111c.462-.331.915-.68,1.349-1.043q.367-.307.725-.632l2.207,3.2a1.462,1.462,0,0,0,2.629-.5l.885-3.852c.434.215,4.16,1.48,4.594,1.643a7.857,7.857,0,0,1,1.479,3.307,3.249,3.249,0,1,0,1.64-.05,9.51,9.51,0,0,0-.433-1.681q-.133-.37-.3-.727l2.912,1.034a7.812,7.812,0,0,1,5.2,7.345Zm-8.1-5.582h0a1.665,1.665,0,1,1-1.624,1.707A1.665,1.665,0,0,1,63.1,47.328Z",
    fill: "#93a750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfectiousSubstancesIcon);
export default __webpack_public_path__ + "static/media/InfectiousSubstancesIcon.e7a33a8900bc2271c40a950a69543fdb.svg";
export { ForwardRef as ReactComponent };